// import * as React from 'react';
// import { showNumberRowsTable } from '../commons/values';
// import { useResponseHandler } from './useResponseHandler';

// interface PaginationState {
//   page: number;
//   take: number;
//   itemCount: number;
//   pageCount: number;
//   hasPreviousPage: boolean;
//   hasNextPage: boolean;
// }

// export const useTableState = (localStorageKey: string, initialOrderBy: string = 'name') => {
//   // Data States
//   const [dataTableList, setDataTable] = React.useState<any[]>([]);
//   const [pagination, setPagination] = React.useState<PaginationState>({
//     page: 1,
//     take: 1,
//     itemCount: 1,
//     pageCount: 1,
//     hasPreviousPage: false,
//     hasNextPage: false
//   });

//   // Selection & Menu States
//   const [openElem, setOpenElem] = React.useState<any>(null);
//   const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

//   // Permission States
//   const [canEdit, setCanEdit] = React.useState<boolean>(false);
//   const [canDelete, setCanDelete] = React.useState<boolean>(false);
//   const [canRestore, setCanRestore] = React.useState<boolean>(false);
//   const [canView, setCanView] = React.useState<boolean>(false);

//   // Pagination UI States
//   const [page, setPage] = React.useState(0);
//   const [pagePagination, setPagePagination] = React.useState(1);
//   const [itemCountPagination, setItemCountPagination] = React.useState(1);
//   const [rowsPerPage, setRowsPerPage] = React.useState(showNumberRowsTable);

//   // Filter & Search States
//   const [checked, setChecked] = React.useState(() => {
//     return localStorage.getItem(localStorageKey) === 'true';
//   });
//   const [searchTerm, setSearchTerm] = React.useState("");

//   // Sorting States
//   const [order, setOrder] = React.useState<'asc' | 'desc'>('asc');
//   const [orderBy, setOrderBy] = React.useState<string>(initialOrderBy);

//   // RESPONSE HANDLER HOOK
//   const { 
//     handleResponse, 
//     ResponseComponents, 
//     handlers,
//     setMessagesAlerts,
//     setTimeAlert,
//     setMsgSnack,
//     setAlertSnack,
//     setModalSessionExpired,
//     modalSessionExpired,
//     timeAlert,
//     alert_snack,
//     messagesAlerts,
//     msgSnack
//   } = useResponseHandler() as any; // Cast as any if TS complains about missing state exports in hook return

//   // Modal States
//   const [openModalDeactivation, setOpenModalDeactivation] = React.useState(false);
//   const [openModalRestore, setOpenModalRestore] = React.useState(false);

//   // Handlers
//   const handleOpenMenu = (elem: any) => (event: React.MouseEvent<HTMLElement>) => {
//     setAnchorEl(event.currentTarget);
//     setOpenElem(elem);
//   };

//   const handleCloseMenu = () => {
//     setAnchorEl(null);
//     setOpenElem(null);
//   };

//   const handleChangePage = (event: unknown, newPage: number) => {
//     setPage(newPage);
//     setPagePagination(newPage + 1);
//   };

//   const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
//     setRowsPerPage(+event.target.value);
//     setPage(0);
//     setPagePagination(1);
//   };

//   const handleSwitchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
//     setChecked(event.target.checked);
//     localStorage.setItem(localStorageKey, event.target.checked.toString());
//   };

//   const debounce = (func: (...args: any[]) => void, delay: number) => {
//     let timer: ReturnType<typeof setTimeout>;
//     return (...args: any[]) => {
//       clearTimeout(timer);
//       timer = setTimeout(() => func(...args), delay);
//     };
//   };

//   const debouncedSearch = React.useMemo(() =>
//     debounce(async (
//       param: string,
//       dispatch: any,
//       searchThunk: any,
//       getInitialData: any,
//       validateResponse: any,
//       searchMsg: string
//     ) => {
//       if (param === '') {
//         getInitialData();
//         return;
//       }
//       if (param.length <= 3) return;

//       const response = await dispatch(searchThunk(param));
//       await handleResponse(response, searchMsg, false);
//     }, 300), [handleResponse]);

//   const handleSearch = (
//     param: string,
//     dispatch: any,
//     searchThunk: any,
//     getInitialData: any,
//     validateResponse: any,
//     searchMsg: string
//   ) => {
//     setSearchTerm(param);
//     debouncedSearch(param, dispatch, searchThunk, getInitialData, validateResponse, searchMsg);
//   };

//   const handleResetSearch = (getInitialData: any) => {
//     setSearchTerm('');
//     getInitialData();
//   };

//   const updatePaginationFromList = (list: any) => {
//     if (!list) return;

//     if (Array.isArray(list)) {
//       setDataTable(list);
//       const calculatedPageCount = Math.ceil(list.length / rowsPerPage);
//       setPagination({
//         page: 1,
//         take: list.length,
//         itemCount: list.length,
//         pageCount: calculatedPageCount,
//         hasPreviousPage: false,
//         hasNextPage: false
//       });
//       setItemCountPagination(calculatedPageCount);
//     } else if (list.data && Array.isArray(list.data)) {
//       setDataTable(list.data);
//       if (list.meta) {
//         setPagination({
//           page: list.meta.page,
//           take: list.meta.take,
//           itemCount: list.meta.itemCount,
//           pageCount: list.meta.pageCount,
//           hasPreviousPage: list.meta.hasPreviousPage,
//           hasNextPage: list.meta.hasNextPage
//         });
//         setItemCountPagination(list.meta.pageCount);
//       }
//     }
//   };

//   const changePaginationPage = (event: React.ChangeEvent<unknown>, value: number) => {
//     setPagePagination(value);
//     setPage(value - 1);
//   };

//   const handleRequestSort = (event: React.MouseEvent<unknown>, property: string) => {
//     const isAsc = orderBy === property && order === 'asc';
//     setOrder(isAsc ? 'desc' : 'asc');
//     setOrderBy(property);
//   };

//   const descendingComparator = (a: any, b: any, orderBy: string) => {
//     if (b[orderBy] < a[orderBy]) return -1;
//     if (b[orderBy] > a[orderBy]) return 1;
//     return 0;
//   };

//   const getComparator = (order: 'asc' | 'desc', orderBy: string) => {
//     return order === 'desc'
//       ? (a: any, b: any) => descendingComparator(a, b, orderBy)
//       : (a: any, b: any) => -descendingComparator(a, b, orderBy);
//   };

//   const getSortedAndFilteredList = (
//     list: any[], 
//     searchKeys: string[] = ['name'], 
//     statusKey: string = 'status',
//     activeStatusValue: any = 1
//   ) => {
//     const filteredList = (list || []).filter((item: any) => {
//       // Si no hay keys de búsqueda o término, matchesSearch es true
//       const matchesSearch = !searchTerm || searchKeys.some(key => 
//         item[key]?.toString().toLowerCase().includes(searchTerm.toLowerCase())
//       );
//       // Si checked (mostrar inactivos) es true, mostramos todos, sino solo los activos
//       const matchesStatus = checked ? true : item[statusKey] === activeStatusValue;
      
//       return matchesSearch && matchesStatus;
//     });

//     return [...filteredList].sort(getComparator(order, orderBy));
//   };

//   return {
//     // States
//     dataTableList, setDataTable,
//     pagination, setPagination,
//     openElem, setOpenElem,
//     anchorEl, setAnchorEl,
//     canEdit, setCanEdit,
//     canDelete, setCanDelete,
//     canRestore, setCanRestore,
//     canView, setCanView,
//     page, setPage,
//     pagePagination, setPagePagination,
//     itemCountPagination, setItemCountPagination,
//     rowsPerPage, setRowsPerPage,
//     checked, setChecked,
//     searchTerm, setSearchTerm,
//     order, setOrder,
//     orderBy, setOrderBy,
//     modalSessionExpired, setModalSessionExpired,
//     timeAlert,
//     alert_snack, setAlertSnack,
//     messagesAlerts, setMessagesAlerts,
//     msgSnack, setMsgSnack,
//     openModalDeactivation, setOpenModalDeactivation,
//     openModalRestore, setOpenModalRestore,
//     ResponseComponents,
//     handleResponse,

//     // Handlers
//     handleOpenMenu,
//     handleCloseMenu,
//     handleChangePage,
//     handleChangeRowsPerPage,
//     handleSwitchChange,
//     updatePaginationFromList,
//     handleSearch,
//     handleResetSearch,
//     changePaginationPage,
//     handleRequestSort,
//     getSortedAndFilteredList
//   };
// };







import * as React from 'react';
import { showNumberRowsTable } from '../commons/values';
import { useResponseHandler } from './useResponseHandler';


interface PaginationState {
  page: number;
  take: number;
  itemCount: number;
  pageCount: number;
  hasPreviousPage: boolean;
  hasNextPage: boolean;
}

export const useTableState = (localStorageKey: string, initialOrderBy: string = 'name') => {
  // Data States
  const [dataTableList, setDataTable] = React.useState<any[]>([]);
  const [pagination, setPagination] = React.useState<PaginationState>({
    page: 1,
    take: 1,
    itemCount: 1,
    pageCount: 1,
    hasPreviousPage: false,
    hasNextPage: false
  });

  // Selection & Menu States
  const [openElem, setOpenElem] = React.useState<any>(null);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  // Permission States
  const [canView, setCanView] = React.useState<boolean>(false);
  const [canEdit, setCanEdit] = React.useState<boolean>(false);
  const [canDelete, setCanDelete] = React.useState<boolean>(false);
  const [canRestore, setCanRestore] = React.useState<boolean>(false);

  // Pagination UI States
  const [page, setPage] = React.useState(0);
  const [pagePagination, setPagePagination] = React.useState(1);
  const [itemCountPagination, setItemCountPagination] = React.useState(1);
  const [rowsPerPage, setRowsPerPage] = React.useState(showNumberRowsTable);
  const [isServerSide, setIsServerSide] = React.useState(false);

  // Filter & Search States
  const [checked, setChecked] = React.useState(() => {
    return localStorage.getItem(localStorageKey) === 'true';
  });
  const [searchTerm, setSearchTerm] = React.useState("");

  // Sorting States
  const [order, setOrder] = React.useState<'asc' | 'desc'>('asc');
  const [orderBy, setOrderBy] = React.useState<string>(initialOrderBy);

  // RESPONSE HANDLER HOOK
  const { 
    handleResponse, 
    ResponseComponents, 
    handlers,
    setMessagesAlerts,
    setTimeAlert,
    setMsgSnack,
    setAlertSnack,
    setModalSessionExpired,
    modalSessionExpired,
    timeAlert,
    alert_snack,
    messagesAlerts,
    msgSnack
  } = useResponseHandler() as any; // Cast as any if TS complains about missing state exports in hook return

  // Modal States
  const [openModalDeactivation, setOpenModalDeactivation] = React.useState(false);
  const [openModalRestore, setOpenModalRestore] = React.useState(false);

  // Handlers
  const handleOpenMenu = (elem: any) => (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
    setOpenElem(elem);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
    setOpenElem(null);
  };

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
    setPagePagination(newPage + 1);
  };

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
    setPagePagination(1);
  };

  const handleSwitchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setChecked(event.target.checked);
    localStorage.setItem(localStorageKey, event.target.checked.toString());
  };

  const debounce = (func: (...args: any[]) => void, delay: number) => {
    let timer: ReturnType<typeof setTimeout>;
    return (...args: any[]) => {
      clearTimeout(timer);
      timer = setTimeout(() => func(...args), delay);
    };
  };

  const debouncedSearch = React.useMemo(() =>
    debounce(async (
      param: string,
      dispatch: any,
      searchThunk: any,
      getInitialData: any,
      validateResponse: any,
      searchMsg: string
    ) => {
      if (param === '') {
        getInitialData();
        return;
      }
      if (param.length <= 2) return;

      const response = await dispatch(searchThunk(param));
      await handleResponse(response, searchMsg, false);
    }, 300), [handleResponse]);

  const handleSearch = (
    param: string,
    dispatch: any,
    searchThunk: any,
    getInitialData: any,
    validateResponse: any,
    searchMsg: string
  ) => {
    setSearchTerm(param);
    debouncedSearch(param, dispatch, searchThunk, getInitialData, validateResponse, searchMsg);
  };

  const handleResetSearch = (getInitialData: any) => {
    setSearchTerm('');
    getInitialData();
  };

  

  const updatePaginationFromList = React.useCallback((list: any) => {

  if (!list) return;


  // Caso: lista simple []
  if (Array.isArray(list)) {
    setIsServerSide(false);
    const itemCount = list.length;

    setDataTable(list);

    setPagination({
      page: 1,
      take: itemCount,
      itemCount,
      pageCount: 1,
      hasPreviousPage: false,
      hasNextPage: false,
    });

    setItemCountPagination(itemCount);
    return;
  }

  // Caso: respuesta paginada { data: [], meta: {} }
  const { data = [], meta } = list;

  if (!Array.isArray(data)) return;

  setDataTable(data);

  if (meta) {
    setIsServerSide(true);
    const {
      page = 1,
      take = data.length || 10,
      itemCount = data.length,
      total,
      pageCount,
      hasPreviousPage = false,
      hasNextPage = false,
    } = meta;

    const actualTotal = total !== undefined ? total : itemCount;
    const actualPageCount = pageCount !== undefined ? pageCount : Math.ceil(actualTotal / (take || 1));

    setPagination({
      page,
      take,
      itemCount: actualTotal,
      pageCount: actualPageCount,
      hasPreviousPage,
      hasNextPage,
    });

    setItemCountPagination(actualPageCount);
  } else {
    setIsServerSide(false);
    const itemCount = data.length;

    setPagination({
      page: 1,
      take: itemCount,
      itemCount,
      pageCount: 1,
      hasPreviousPage: false,
      hasNextPage: false,
    });

    setItemCountPagination(1);
  }
}, []);



  const changePaginationPage = (event: React.ChangeEvent<unknown>, value: number) => {
    setPagePagination(value);
    setPage(value - 1);
  };


  
  const handleRequestSort = (event: React.MouseEvent<unknown>, property: string) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const descendingComparator = (a: any, b: any, orderBy: string) => {
    if (b[orderBy] < a[orderBy]) return -1;
    if (b[orderBy] > a[orderBy]) return 1;
    return 0;
  };

  const getComparator = (order: 'asc' | 'desc', orderBy: string) => {
    return order === 'desc'
      ? (a: any, b: any) => descendingComparator(a, b, orderBy)
      : (a: any, b: any) => -descendingComparator(a, b, orderBy);
  };

  const getSortedAndFilteredList = (
    list: any[], 
    searchKeys: string[] = ['name'], 
    statusKey: string = 'status',
    activeStatusValue: any = 1
  ) => {
    const filteredList = (list || []).filter((item: any) => {
      // Si no hay keys de búsqueda o término, matchesSearch es true
      const matchesSearch = !searchTerm || searchKeys.some(key => {
        const keys = key.split('.');
        let val = item;
        for (const k of keys) {
            val = val ? val[k] : undefined;
        }
        return val?.toString().toLowerCase().includes(searchTerm.toLowerCase());
      });
      // Si checked (mostrar inactivos) es true, mostramos todos, sino solo los activos
      const matchesStatus = checked ? true : item[statusKey] === activeStatusValue;
      
      return matchesSearch && matchesStatus;
    });

    return [...filteredList].sort(getComparator(order, orderBy));
  };

  return {
    // States
    dataTableList, setDataTable,
    pagination, setPagination,
    openElem, setOpenElem,
    anchorEl, setAnchorEl,
    canView, setCanView,
    canEdit, setCanEdit,
    canDelete, setCanDelete,
    canRestore, setCanRestore,
    page, setPage,
    pagePagination, setPagePagination,
    itemCountPagination, setItemCountPagination,
    rowsPerPage, setRowsPerPage,
    checked, setChecked,
    order, setOrder,
    orderBy, setOrderBy,
    searchTerm, setSearchTerm,
    modalSessionExpired, setModalSessionExpired,
    timeAlert,
    alert_snack, setAlertSnack,
    messagesAlerts, setMessagesAlerts,
    msgSnack, setMsgSnack,
    openModalDeactivation, setOpenModalDeactivation,
    openModalRestore, setOpenModalRestore,
    ResponseComponents,
    handleResponse,

    // Handlers
    handleOpenMenu,
    handleCloseMenu,
    handleChangePage,
    handleChangeRowsPerPage,
    handleSwitchChange,
    updatePaginationFromList,
    handleSearch,
    handleResetSearch,
    changePaginationPage,
    handleRequestSort,
    getSortedAndFilteredList,
    isServerSide, setIsServerSide
  };
};

